import { HttpParams } from '@angular/common/http';

export interface Pagination {
  page?: number;
  size?: number;
  sort?: string[];
}

export interface Search {
  query?: {[key: string]: string | number | boolean};
}

/* export interface AccessHistorySearch extends Pagination {
  creationTimeFrom?: string;
  requestCountry: string;
  deviceName: string;
  deviceApplication: string;
}*/

export interface SearchWithPagination extends Search, Pagination {}

export const createRequestOption = (req?: SearchWithPagination): HttpParams => {
  let options: HttpParams = new HttpParams();

  if (req) {
    Object.keys(req).forEach((key: string) => {
      const value : string | number | boolean = (req as any)[key];

      if (key !== 'sort' && key !== 'query') {
        options = options.set(key, value);
      }
    });

    if (req.sort) {
      req.sort.forEach((val: string) => {
        options = options.append('sort', val);
      });
    }

    if(req.query) {
      Object.keys(req.query).forEach((key: string) => {
        options = options.set(key, req.query![key]);
      })
    }
  }

  return options;
};
